export default __webpack_public_path__ + "static/media/14.f8f58fb8.jpg";